export default __webpack_public_path__ + "static/media/fad-random-2dice.854d58de.svg";